import { render, staticRenderFns } from "./WalletBill.vue?vue&type=template&id=7e5c734a&scoped=true"
import script from "./WalletBill.vue?vue&type=script&lang=js"
export * from "./WalletBill.vue?vue&type=script&lang=js"
import style0 from "./WalletBill.vue?vue&type=style&index=0&id=7e5c734a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5c734a",
  null
  
)

export default component.exports